export const category={
    COLLABOLATION:[
      {
        id:'best-all-1', 
        images:[
          `${process.env.PUBLIC_URL}/images/1000607217412_i1_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000607217412_i2_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000607217412_i3_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000607217412_i4_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000607217412_i5_1200.jpg`,
        ],
        name:'랜더스X M&N RED', 
        review:367, 
        price:139000,
        discountPrice: 139000,
        colors: ['RED'],
        sizes: ['S', 'M','L'],
        description:`${process.env.PUBLIC_URL}/images/121000607217412_d1.png`
      },
      {
        id:'best-all-2', 
        images:[
          `${process.env.PUBLIC_URL}/images/1000602870281_i1_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000602870281_i2_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000602870281_i3_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000602870281_i4_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000602870281_i5_1200.jpg`,
        ],
        name:'랜더스X알파MA-1건메탈', 
        review:962, 
        price:289000 , 
        discountPrice: 279000,
        colors: ['GRAY'],
        sizes: ['S', 'M','L','XL','2XL'],
        description:`${process.env.PUBLIC_URL}/images/101000602870281_d1.jpg`,
      },
      {
        id:'best-all-3', 
        images:[
          `${process.env.PUBLIC_URL}/images/1000602870285_i1_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000602870285_i2_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000602870285_i3_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000602870285_i4_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000602870285_i5_1200.jpg`,          
        ],
        name:'랜더스X알파MA-1블랙', 
        review:1287, 
        price:289000 , 
        discountPrice:269000, 
        colors: ['BLACK'],
        sizes: ['S', 'M','L','XL','2XL'],
        description:`${process.env.PUBLIC_URL}/images/101000602870285_d1.jpg`
      },
      {
        id:'best-all-4', 
        images:[
          `${process.env.PUBLIC_URL}/images/1000607217273_i1_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000607217273_i2_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000607217273_i3_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000607217273_i4_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000607217273_i5_1200.jpg`,
        ],
        name:'랜더스X M&N Cream', 
        review:49, 
        price:199000 ,
        discountPrice:199000,
        colors: ['CREAM'],
        sizes: ['S', 'M','L','XL'],
        description:`${process.env.PUBLIC_URL}/images/121000607217273_d1.png`
      },
    ],
    JERSEYS:[
      {
        id:'best-jerseys-1', 
        images:[
          `${process.env.PUBLIC_URL}/images/1000689938868_i1_1200.jpg`,
          `${process.env.PUBLIC_URL}/images/1000689938868_i2_1200.jpg`,
        ],
        name:'25 뉴옐로우 에디션 유니폼', 
        review:367, 
        price:125000,
        discountPrice:125000,
        colors: ['YELLOW'],
        sizes: ['ONE SIZE'], 
        description:`${process.env.PUBLIC_URL}/images/img_description.jpg`
      },
      {
        id:'best-jerseys-2', 
        images:[
          `${process.env.PUBLIC_URL}/images/df451e6e-9fd5-4b9f-9ecd-e48537bdfd4a20250321.jpg`,
        ],
        name:'랜더스 어센틱 어웨이 유니폼', 
        review:962, 
        price:145000, 
        discountPrice:145000,
        colors: ['RED'],
        sizes: ['ONE SIZE'],
        description:`${process.env.PUBLIC_URL}/images/img_description.jpg`
      },
      {
        id:'best-jerseys-3', 
        images:[
          `${process.env.PUBLIC_URL}/images/5ebf8f2e-9d56-4775-b0cc-1d24d42b011520250407.jpg`,
        ],
        name:'랜더스 어센틱 그린 유니폼', 
        review:1287, 
        price:145000, 
        discountPrice:145000,
        colors: ['GREEN'],
        sizes: ['ONE SIZE'],
        description:`${process.env.PUBLIC_URL}/images/img_description.jpg`
      },
      {
        id:'best-jerseys-4', 
        images:[
          `${process.env.PUBLIC_URL}/images/27d6da75-f408-47da-880f-9ab47a125a8220250321.jpg`,
        ],
        name:'랜더스 어센틱 홈 유니폼', 
        review:49, 
        price:145000,
        discountPrice:145000,
        colors: ['WHITE'],
        sizes: ['ONE SIZE'], 
        description:`${process.env.PUBLIC_URL}/images/img_description.jpg`
      },
    ],
    CAPS:[
      {
        id:'best-caps-1', 
        images:[
          `${process.env.PUBLIC_URL}/images/4db8aff6-41c3-41de-b930-71b3ad4ad00720250321.jpg`,
        ],
        name:'랜더스 어센틱 레드 모자', 
        review:367, 
        price:50000,
        discountPrice:50000,
        colors: ['RED'],
        sizes: ['ONE SIZE'],
        description:`${process.env.PUBLIC_URL}/images/f76135b1-2184-4ddd-95d6-582a833e622c20250321.jpg`
      },
      {
        id:'best-caps-2', 
        images:[
          `${process.env.PUBLIC_URL}/images/cec2a8fa-255e-4c4a-baf2-903b358be3d820250321.jpg`,
        ],
        name:'랜더스 어센틱 인천 모자', 
        review:962, 
        price:50000, 
        discountPrice:50000,
        colors: ['BLACK'],
        sizes: ['ONE SIZE'], 
        description:`${process.env.PUBLIC_URL}/images/d92f003b-a39b-478d-a9be-8bc0568e746220250321.jpg`
      },
      {
        id:'best-caps-3', 
        images:[
          `${process.env.PUBLIC_URL}/images/7b6b2017-00e4-4505-98c6-d2d2da9f0e9920240514.jpg`,
        ],
        name:'랜더스 인천 버클캡', 
        review:1287, 
        price:42000, 
        discountPrice:42000,
        colors: ['BLACK'],
        sizes: ['ONE SIZE'], 
        description:`${process.env.PUBLIC_URL}/images/c200b19a-342e-470c-9bd4-9afc3260a2fb20240514.jpg`
      },
      {
        id:'best-caps-4', 
        images:[
          `${process.env.PUBLIC_URL}/images/50d1e6b9-6341-4c58-b97d-26a58125558720250321.jpg`,
        ],
        name:'랜더스 어센틱 그린 모자', 
        review:49, 
        price:50000,
        discountPrice:50000,
        colors: ['GREEN'],
        sizes: ['ONE SIZE'],
        description:`${process.env.PUBLIC_URL}/images/705705e4-6be3-4f99-836e-d5325429af1e20250321.jpg`
      },
    ],
    ETC:[
      {
        id:'best-etc-1', 
        images:[
          `${process.env.PUBLIC_URL}/images/9ab46cde-155a-493c-aee6-1f3f78036ed320250529.jpg`,
        ],
        name:'랜더스 로고볼', 
        review:367, 
        price:7000,
        discountPrice:7000,
        colors: ['BLACK'],
        sizes: ['ONE SIZE'],
        description:`${process.env.PUBLIC_URL}/images/6724d51d-708e-4999-8651-ec0cfef375ad20250529.jpg`
      },
      {
        id:'best-etc-2', 
        images:[
          `${process.env.PUBLIC_URL}/images/35c7879f-3893-4de7-809a-c473b1b1c87220240724.jpg`,
        ],
        name:'랜더스 핸디 선풍기', 
        review:962, 
        price:29000, 
        discountPrice:29000,
        colors: ['BLACK'],
        sizes: ['ONE SIZE'],
        description:`${process.env.PUBLIC_URL}/images/718881b1-d15f-473d-9ae7-e81534caf00d20240724.jpg`
      },
      {
        id:'best-etc-3', 
        images:[
          `${process.env.PUBLIC_URL}/images/60e50fd4-c131-4a42-806b-3666d158713120250516.png`,
        ],
        name:'랜더스x깜자 인형', 
        review:1287, 
        price:35000, 
        discountPrice:30000,
        colors: ['BLACK'],
        sizes: ['ONE SIZE'], 
        description:`${process.env.PUBLIC_URL}/images/3898cd68-42e0-4983-85da-f92798984bf820250516.jpg`
      },
      {
        id:'best-etc-4', 
        images:[
          `${process.env.PUBLIC_URL}/images/0910c7b0-9267-4e4c-ab6e-8da53c773cd120250724.png`,
        ],
        name:'랜더스 25 인천 유니폼 키링', 
        review:49, 
        price:12000,
        discountPrice:12000,
        colors: ['BLACK'],
        sizes: ['ONE SIZE'],
        description:`${process.env.PUBLIC_URL}/images/c89424ae-8a6f-44fb-888b-de235fc0eee620250724.jpg`
      },
      
    ],
    SPECIAL:[
        {
          id:'best-etc-1', 
          images:[
            `${process.env.PUBLIC_URL}/images/8da98346-cdbf-402e-ba5d-d71c63db3d6a20250627.png`,
          ],
          name:'김강민 은퇴 기념 유니폼', 
          review:367, 
          price:149000,
          discountPrice:92000,
          colors: ['BLACK'],
          sizes: ['S','M','L','XL'],
          description:`${process.env.PUBLIC_URL}/images/bf91cc16-1fea-4ef0-bf5a-59516177cfd420250628.jpg`
        },
        {
          id:'best-etc-2', 
          images:[
            `${process.env.PUBLIC_URL}/images/2e2e1087-62d8-4dba-a03c-638f858a8bec20250627.png`,
          ],
          name:'김강민 은퇴 기념 모자', 
          review:962, 
          price:49000, 
          discountPrice:49000,
          colors: ['BLACK'],
          sizes: ['ONE SIZE'],
          description:`${process.env.PUBLIC_URL}/images/251dcd25-d594-476b-8a47-cf7af2f235d720250628.jpg`
        },
        {
          id:'best-etc-3', 
          images:[
            `${process.env.PUBLIC_URL}/images/82d4fdd2-854d-4dc2-93d3-1ebb78f711ac20250627.png`,
          ],
          name:'김강민 은퇴 기념구', 
          review:1287, 
          price:35000, 
          discountPrice:30000,
          colors: ['BLACK'],
          sizes: ['ONE SIZE'], 
          description:`${process.env.PUBLIC_URL}/images/8f006325-13b7-4dc4-8ac3-0dfff1fd24c920250627.jpg`
        },
        {
          id:'best-etc-4', 
          images:[
            `${process.env.PUBLIC_URL}/images/a2111ae1-3f09-474e-acdc-481df57ced1b20250627.png`,
          ],
          name:'김강민 은퇴 기념 아크릴 키링', 
          review:49, 
          price:10000,
          discountPrice:9000,
          colors: ['BLACK'],
          sizes: ['ONE SIZE'],
          description:`${process.env.PUBLIC_URL}/images/6cfa586a-4f45-4881-aa60-7efcfb37799820250627.jpg`
        },
        
      ],
    
  }